export const fileToBinaryString = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result as string)
    reader.onerror = reject
    reader.readAsBinaryString(file)
  })

export const blobToBase64 = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result as string)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })

/**
 * Builds the multipart/form-data body for an S3 presigned POST. Policy fields
 * must come first and the file LAST, or S3 rejects it.
 */
export const toPresignedPostFormData = (
  fields: Record<string, string>,
  file: Blob,
  filename?: string
) => {
  const formData = new FormData()
  for (const [key, value] of Object.entries(fields)) {
    formData.append(key, value)
  }
  formData.append('file', file, filename)
  return formData
}
